import { Badge, Card, Col, Row } from "react-bootstrap"
import { fechaATexto } from "../../lib/helpers/helpers"
import { GrConnectivity } from 'react-icons/gr'
import { MdOutlineShareLocation } from "react-icons/md"

const BoxList = (props) => {
    const ruta = props.ruta ? props.ruta : false
    const seleccionado = props.seleccionado ? props.seleccionado : false

    if(!ruta) return false

    const clickRuta = (id) => {
        if(props.onClickRuta) return props.onClickRuta(id)
        return false
    }

    const mostrarVehiculo = (driver) => {
        if(!driver) return false
        return <div>
            <hr className={`${seleccionado === true ? 'hr border-white' : 'hr border-primary'}`} />
            <h6 className="mb-0" style={{ fontWeight: 700 }}><b>{driver.modelo}</b> {driver.ano}</h6>
            <h6 className="mb-0" style={{ fontWeight: 700 }}>PATENTE: <b>{driver.patente ? driver.patente.toUpperCase() : "SIN PATENTE"}</b></h6>
        </div>
    }

    return <Card bg={ seleccionado === true ? 'primary' : 'white' } className={`p-3 shadow ${seleccionado === true ? 'text-white' : 'text-primary'}`} onClick={() => clickRuta(ruta._id)}>
        { ruta.tipo_asignacion === "proveedor" ? <Badge variant="warning" className="mb-1" ><MdOutlineShareLocation style={{ verticalAlign: "middle" }} /><b> PROVEEDOR EXTERNO</b></Badge> : false }
        <p style={{ fontSize: 11 }} className="mb-0"><b>Creado</b> {fechaATexto(ruta.createdAt)}</p>
        <h6 className="mb-0" style={{fontWeight:900}}>RUTA {ruta.id} · <b style={{ fontWeight:'lighter' }}>{ruta.pedidos} ÓRDENES</b></h6>
        { ruta.descripcion ? <span style={{ fontSize:11, fontWeight: "normal" }}>{ruta.descripcion}</span> : false }
        { ruta.finalizada ? <h6 className="mb-0 mt-1"><i className="fa-solid fa-stop text-danger"></i> FINALIZADA</h6> : <h6 className="mb-0 mt-1"><i className="fa-solid fa-play text-success"></i> EN CURSO</h6> }
        <h6 className="mb-0"></h6>
        {mostrarVehiculo(ruta.vehiculo)}
</Card>
}

export default BoxList